import 'react-toastify/dist/ReactToastify.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';


const SkeletonLayout = () => {
 

  return (
 <>
  <SkeletonTheme
    baseColor="#dee2e6"
    highlightColor="#f8f9fa"
    borderRadius="0.75rem"
    duration={1.2}
  >
    {/* Header Skeleton */}
    <div className="mb-3">
      <Skeleton height={60} className="rounded" />
    </div>

    <div className="container py-4">
      {/* Large banner skeleton */}
      <Skeleton height={250} className="rounded mb-4" />

      {/* First Card Section */}
      <div className="row">
        {[1, 2, 3].map((item, index) => (
          <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
            <div className="card p-3 rounded-4 shadow-sm h-100 bg-light border-0 animate__animated animate__fadeInUp">
              <Skeleton height={180} className="rounded" />
              <Skeleton height={20} width="85%" className="mt-3" />
              <Skeleton height={20} width="65%" className="mt-2" />
              <Skeleton height={30} width="45%" className="mt-3" />
            </div>
          </div>
        ))}
      </div>

      {/* Wide Full Section */}
      <div className="card p-3 rounded-4 shadow-sm mb-4 bg-light border-0 animate__animated animate__fadeIn">
        <Skeleton height={20} width="70%" className="mt-2" />
        <Skeleton height={30} width="50%" className="mt-3" />
      </div>

      {/* Second Card Section */}
      <div className="row">
        {[1, 2, 3].map((item, index) => (
          <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
            <div className="card p-3 rounded-4 shadow-sm h-100 bg-light border-0 animate__animated animate__fadeInUp">
              <Skeleton height={180} className="rounded" />
              <Skeleton height={20} width="80%" className="mt-3" />
              <Skeleton height={20} width="60%" className="mt-2" />
              <Skeleton height={30} width="40%" className="mt-3" />
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Footer Skeleton */}
    <div className="px-3">
      <Skeleton height={100} className="rounded" />
    </div>
  </SkeletonTheme>
    </>
  );
};

export default SkeletonLayout;
